var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsightTests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2639_5505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1177 16.4598V15.026C11.1837 14.5038 11.6603 14.1524 12.1985 14.1524H12.7902C13.7838 14.1524 14.5892 13.3648 14.5892 12.3933V10.7697C15.2612 10.7953 15.6097 10.7416 16.0101 10.5002C16.4113 10.2583 16.5445 9.75707 16.4079 9.31594C15.2058 5.4357 13.3313 1.54019 7.99226 1.54019C3.89927 1.54019 1.54016 3.59244 1.54016 7.69693C1.54016 10.5017 2.28871 11.4431 3.19439 12.8757C3.69298 13.6643 3.90354 14.5859 3.9009 15.5131C3.89996 15.8448 3.89927 16.1821 3.89927 16.4598",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.81439 6.81481C5.8397 6.17558 6.25102 4.89713 7.69396 4.89713C9.49762 4.89713 9.63313 6.47793 9.6495 6.81481C9.6495 8.08513 7.68179 8.19432 7.77619 9.40627V9.70019",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69275 11.7322V11.9903",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2639_5505"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightTests);
export default __webpack_public_path__ + "static/media/insight_tests.b41628427dc2b00ffa45efe1754517c4.svg";
export { ForwardRef as ReactComponent };